var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('button-menu',{attrs:{"items":_vm.menu}}),_c('b-button',{staticClass:"d-md-none",attrs:{"variant":"secondary","to":"/menu-principal","block":""}},[_vm._v(" Volver ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }